<formats-list
  *ngIf="(collection?.meta | async)?.total > 0"
  [formatsCollection]="collection"
  [colors]="colors"
  (select)="onSelectFormat($event)"
  (loadNext)="loadNextFormats()"
>
</formats-list>
